import { PureComponent } from "react";

import ParagraphComponent from "../paragraph/paragraph-component";
import ImagesGalleryComponent from "../images-gallery/images-gallery-component";
import { isContentEmpty } from "/services/paragraph-service";

import { StyledParagraphWithLogosComponent } from "./paragraph-with-logos-component.scss";

export default class ParagraphWithLogosComponent extends PureComponent {
  render() {
    const { paragraph, mobileImageWidthRatio, assets, shadow, textColor } = this.props;
    const screenRatios = { mobile: mobileImageWidthRatio };
    const withContent = !isContentEmpty(paragraph);
    return (
      <StyledParagraphWithLogosComponent className="paragraph-with-logos-component">
        {withContent && (
          <div className="paragraph-wrapper">
            <ParagraphComponent {...paragraph} textColor={textColor} />
          </div>
        )}
        <div className="image-gallery-wrapper">
          <ImagesGalleryComponent assets={assets} shadow={shadow} screenRatios={screenRatios} />
        </div>
      </StyledParagraphWithLogosComponent>
    );
  }
}
